var divider_viewer_rtlignore_default = {
  "divider-container": "R1FDU",
  "divider-container--double": "CcCw0",
  "divider": "bX3AI",
  "divider--single": "f5cAW",
  "divider--double": "_4a2s7",
  "divider--dashed": "_0ZjRA",
  "divider--dotted": "mU8w3",
  "divider--small": "EE4kW",
  "divider--medium": "ZF6rW",
  "divider--large": "SGrbh",
  "divider--left": "EZcKN",
  "divider--center": "_5I-4h",
  "divider--right": "iQpds",
  "svgFixerContainer": "_3F0XS",
  "emptyChar": "DUihX"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
